import Hero from '../components/Hero'
import ServicePageLayout from '../components/ServicePageLayout'
import CallToActionLayout from '../components/CallToActionLayout'
import JourneySection from '../components/JourneySection'
import { journeySteps } from '../data/gaiaCustomerStory'
import heatPumpImage from '../assets/images/heat_pump_presentation.png'

const HeatPumps = () => {
  const heroContent = {
    title: 'Air Source Heat Pumps',
    subtitle: 'Efficient All-Season Home Comfort',
    description: 'Upgrade to an eco-friendly heating system that provides both heating and cooling. Reduce your heating costs and carbon emissions while enjoying year round comfort.',
    grantAmount: '£7,500',
    ctaText: 'Get Heat Pump Quote',
    ctaLink: '/quote/heat-pumps',
    secondaryCtaText: 'Learn More',
    secondaryCtaLink: '#benefits',
    image: heatPumpImage,
    imageAlt: 'Modern air source heat pump installation',
  }

  const serviceData = {
    title: "Air Source Heat Pumps",
    subtitle: "Efficient heating and cooling for modern homes",
    description: "Upgrade to an eco-friendly heating system with our air source heat pumps. Enjoy year-round comfort while reducing your carbon footprint and heating costs by up to 50%.",
    benefits: [
      "Reduction in heating costs",
      "Provides both heating and cooling",
      "Extremely energy efficient (300-400% efficiency)",
      "Low carbon footprint",
      "Government Boiler Upgrade Scheme grants available",
      "Long lifespan (15-20 years)"
    ],
    features: [
      {
        title: "Lower Energy Bills",
        description: "Efficient heating that reduces energy use and helps cut running costs."
      },
      {
        title: "Comfortable Heat All Year",
        description: "Steady, even warmth with reliable hot water whenever you need it."
      },
      {
        title: "Simple to Control",
        description: "Easy-to-use smart controls let you manage your heating from your phone or wall thermostat."
      },
      {
        title: "Quiet and Unobtrusive",
        description: "Designed to operate quietly, without disrupting your home or outdoor space."
      },
      {
        title: "Reduced Carbon Impact",
        description: "Low-carbon heating that helps lower your home’s environmental footprint."
      },
      {
        title: "Ready for the Future",
        description: "Designed to work with solar panels, battery storage, and future energy tariffs."
      }
    ],
    videoEmbedId: "false" // Placeholder YouTube ID
  }

  return (
    <div>
      <Hero
        layout="split"
        content={heroContent}
      />
      <div id="benefits">
        <ServicePageLayout {...serviceData} />
      </div>

      {/* Journey Section */}
      <JourneySection
        title="Live in hotel-like comfort at home"
        steps={journeySteps}
        backgroundColor="gray"
      />
      <CallToActionLayout
        cta_title="Ready to ditch the boiler?"
        description="Get a free, personalised quotation for your heat pump installation. 
        Our experts will assess your home and provide detailed cost projections and savings estimates."
        quote_link='/quote/heat-pumps'
      />
    </div>
  )
}

export default HeatPumps